import { render } from "./ImageBlock.vue?vue&type=template&id=97842e24&scoped=true"
import script from "./ImageBlock.vue?vue&type=script&lang=js"
export * from "./ImageBlock.vue?vue&type=script&lang=js"

import "./ImageBlock.vue?vue&type=style&index=0&id=97842e24&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97842e24"]])

export default __exports__